<template>
  <div>
    <el-menu
      v-if="getAccesToken"
      class="menu"
      :default-active="propsCurrentIndex"
      mode="horizontal"
      background-color="#fff"
      text-color="#252525"
      active-text-color="#E87305"
      :router="true"
    >
      <div class="menu-state" v-if="getMenuIsDisable" />

      <img
        @click="goToHome()"
        class="menu-img"
        width="230"
        height="38"
        src="./assets/Rateio_Indireto_Header.svg"
        alt=""
      />

      <el-menu-item
        v-for="item in propsNavItems"
        :key="item.index"
        :index="item.index"
        :route="item.route"
        :disabled="item.disabled"
        >{{ item.vText }}</el-menu-item
      >

      <div class="right-items">
        <el-dropdown class="dropmenu" @command="handleCommand">
          <el-button class="current-location-btndrop">
            {{ currentLocation.name
            }}<i class="el-icon-arrow-down el-icon--right"></i>
          </el-button>
          <el-dropdown-menu slot="dropdown" style="width: 170px">
            <el-dropdown-item
              v-for="(item, index) in locations"
              :key="index"
              class="subdropitem"
              :command="item.name"
              >{{ item.name }}</el-dropdown-item
            >
            <el-dropdown-item
              v-if="currentLocation.name !== defaultCurrentLocation"
              class="subdropitem"
              :command="defaultCurrentLocation"
              >{{ defaultCurrentLocation }}</el-dropdown-item
            >
          </el-dropdown-menu>
        </el-dropdown>

        <div style="margin-left: 30px">
          <el-dropdown class="dropmenu" @command="handleCommand">
            <div class="avatarStyle">
              <div>
                <el-avatar style="background: #e87305; font-weight: bold">
                  {{ avatarName }}</el-avatar
                >
              </div>
              <div class="avatar-name">
                <span>{{ userName }}</span
                ><i class="el-icon-arrow-down el-icon--right"></i>
              </div>
            </div>
            <el-dropdown-menu slot="dropdown" style="width: 150px">
              <el-dropdown-item class="subdropitem" command="logout"
                >Sair</el-dropdown-item
              >
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </div>
    </el-menu>

    <transition name="fade" mode="out-in">
      <router-view
        style="padding-top: 100px; padding-left: 30px; padding-right: 30px"
      />
    </transition>
    <div class="footer" v-if="getAccesToken">
      <div class="app-title">
        <span>Rateio Indireto</span>
      </div>
      <div class="app-version">
        <span>{{ VERSION }}</span>
      </div>
    </div>
  </div>
</template>

<style>
.el-table .cell {
  word-break: break-word;
  padding-right: 0px !important;
}
.el-button {
  background: #e87305;
  padding-top: 8px;
  padding-left: 12px;
  padding-right: 12px;
  padding-bottom: 8px;
  color: #fff;
  font-weight: bold;
  font-size: 12px;
}

.el-button:hover {
  background: #c76000;
  color: #fff;
}

.el-button:focus {
  background: #e87305;
  color: #fff;
}

.el-button:disabled {
  background: #e87305;
  opacity: 0.5;
}

.el-button:disabled:hover {
  background: #e87305;
  opacity: 0.5;
}

.icon-beaut {
  cursor: pointer;
  margin-right: 4px;
}

.icon-beaut:hover {
  color: #e87305;
}

.el-drawer__header > :first-child {
  font-size: 14px !important;
}

.el-select-dropdown.is-multiple .el-select-dropdown__item.selected {
  color: #e87305 !important;
  font-size: 12px !important;
}

.el-select-dropdown__item {
  font-size: 12px !important;
}

.footer {
  position: fixed;
  left: 0;
  bottom: 0;
  width: 100%;
  background-color: #e9e9e9;
  color: #7e7e7e;
  padding: 12px;
  padding-left: 20px;
  padding-right: 20px;
  font-size: 14px;
  display: flex;
  justify-content: space-between;
}

.my-header {
  background: blue !important;
}

.confirm-items {
  display: flex;
  padding-top: 8px;
  padding-right: 15px !important;
}

.center {
  margin-left: 7%;
  margin-top: 10px;
}

.title_ {
  color: #515151;
  font-weight: bold;
}

.link-download {
  font-size: 14px;
  cursor: pointer;
  font-weight: bold;
  text-decoration: none;
  color: rgb(0, 140, 202);
}

.link-download:hover {
  color: rgb(0, 140, 202);
  text-decoration: underline;
}

.btnFalses {
  background-color: #e87305 !important;
  border: none;
}

.btnFalses:hover {
  background-color: #d66800 !important;
  border: none;
}

.btnCancelFalses {
  background-color: #eaeaea !important;
  color: #515151 !important;
  border: none;
}

.right-position {
  display: flex;
  margin-top: 20px;
}

.header-date {
  margin-right: 20px;
}

.alert-class {
  padding-bottom: 20px;
}

.el-icon-close:hover {
  color: #e87305 !important;
}

.el-loading-mask .is-fullscreen .el-loading-fade-enter-active .el-loading-fade-enter-to {
  color: #e87305 !important;
}

.el-loading-spinner i {
  color: #e87305 !important;
}

.el-loading-spinner .el-loading-text {
  color: #e87305 !important;
}

.pagination {
  color: #515151;
  display: flex;
  margin-right: 30px;
  align-items: center;
  justify-content: space-between;
  align-content: center;
}

.current-location-btndrop {
  height: 43px !important;
  width: 155px;
  font-size: 14px !important;
  background-color: #f1f1f1 !important;
  border: none !important;
  color: #e87305 !important;
  font-weight: normal !important;
}

.avatarStyle {
  display: flex;
}

.avatar-name {
  margin-left: 10px;
  align-self: center;
}

.text-input {
  padding: 7px;
  padding-left: 12px;
  font-size: 14px;
  color: #555;
  font-weight: normal;
  border: 1px solid #dfdfdf;
  border-radius: 5px;
  outline: none;
}

.text-input:hover {
  border: 1px solid #e87305;
}

.text-input:focus {
  border: 1px solid #e87305;
}

.right-items {
  align-items: center;
  display: flex;
  margin-right: 0px;
  margin-left: auto;
  margin-right: 10px !important;
}

.drawer {
  display: flex;
  flex-direction: column;
  height: 100%;
}

.drawer-content {
  display: flex;
  flex-direction: column;
  margin-left: 25px;
  margin-top: 40px;
  justify-content: space-between;
  height: 100%;
  margin-bottom: 30px;
}

.drawer-footer {
  display: flex;
  justify-content: end;
  margin-right: 20px;
}

.drawer-inner-content {
  display: flex;
  align-items: center;
}

.drawer-text-sm {
  font-size: 12px;
  margin-top: 15px;
  margin-bottom: 10px;
}

.el-drawer__header > :first-child {
  font-weight: bold;
}

.drawer-text {
  font-size: 14px;
  margin-top: 8px;
}

.drawer-text-title {
  font-weight: bold;
  font-size: 14px;
}

.drawer-text-header {
  display: flex;
  flex-direction: column;
  margin-left: 25px;
}

.el-icon-search {
  margin-top: -3px;
}

.el-input__inner:hover {
  border-color: #e87305;
}

.el-input__inner:active {
  border-color: #e87305;
}

.el-input__inner:focus {
  border-color: #e87305;
}

.title_ {
  color: #353535;
  font-weight: bold;
  font-size: 14px;
}

.header-title {
  margin-bottom: 30px;
  display: flex;
  justify-content: space-between;
}
.el-progress-bar__innerText {
  font-size: 10px !important;
}

.el-progress-bar {
  width: 100%;
}

.el-progress__text {
  font-size: 10px !important;
  font-weight: bold !important;
}

.menu {
  padding-left: 15px !important;
  padding-right: 15px !important;
  position: fixed !important;
  display: flex !important;
  width: 100% !important;
  z-index: 2;
  transition: visibility 0s, opacity 0.5s linear;
}

.menu-state {
  position: absolute;
  z-index: 4;
  width: 100%;
  height: 60px;
  background-color: #fff;
  opacity: 0.6;
}

.dropmenu {
  margin-top: 0px;
}

.subdropitem:hover {
  color: #e87305 !important;
}

.btnprimary {
  background-color: #e2e2e2 !important;
  color: #e87305 !important;
  border: 0px !important;
}

.menu-img {
  cursor: pointer;
  margin-top: 10px;
  margin-right: 15px;
}

.item {
  text-decoration: none;
  color: #424242;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
  transform: translateX(2em);
}

.no-content-text {
  position: absolute;
  top: 40%;
  left: 50%;
  margin-right: -50%;
  transform: translate(-50%, -50%);
}
.el-icon-close:hover {
  color: #e87305 !important;
}

.el-month-table td.current:not(.disabled) .cell {
  color: #e87305 !important;
}

.el-month-table td .cell:hover {
  color: #e87305 !important;
}

.el-icon:hover {
  color: #e87305 !important;
}

.btn-next:hover {
  color: #e87305 !important;
}

.btn-prev:hover {
  color: #e87305 !important;
}

.fade-enter-active,
.fade-leave-active {
  transition: all 0.09s ease;
}

.number.active {
  color: #e87305 !important;
}

.number:hover {
  color: #e87305 !important;
}

.el-table .descending .sort-caret.descending {
  border-top-color: #e87305 !important;
}

.el-table .ascending .sort-caret.ascending {
  border-bottom-color: #e87305 !important;
}

.el-pagination {
  margin-top: 30px !important;
  display: flex !important;
  justify-content: end;
  margin-right: 0px;
}

.el-pagination__total {
  align-self: flex-start !important;
  margin-right: auto;
}

.el-pagination__total::before {
  align-self: flex-start !important;
  margin-right: auto;
  content: "Quantidade de itens: ";
}
</style>

<script>
import { mapActions, mapGetters } from "vuex";
import store from "./utils/store";
import api from "./utils/api";

export default {
  name: "App",
  data() {
    return {
      menuIsDisable: false,
      userName: "",
      avatarName: "",
      locations: [],
      currentLocation: { name: null, id: null },
      defaultCurrentLocation: "Todas as filiais",
      VERSION: process.env.VUE_APP_VERSION,
    };
  },
  computed: {
    ...mapGetters(["getAccesToken", "getMenuIsDisable"]),
    propsNavItems() {
      return store.state.navItems;
    },
    propsCurrentIndex() {
      return store.state.navCurrentIndex;
    },
  },
  watch: {
    getAccesToken: function () {
      this.start();
    },
  },
  async created() {
    this.start();
  },
  methods: {
    ...mapActions(["logout", "updateRegionId"]),
    async start() {
      if (this.getAccesToken) {
        this.getAvatarName();
        const regionId = localStorage.getItem("regionId");
        if (
          regionId &&
          regionId !== "null" &&
          window.location.pathname !== "/"
        ) {
          const { data } = await api.get("/findLocations");
          const currentLocation = data.find((e) => e.id === regionId);
          this.currentLocation = currentLocation;
          this.updateRegionId(currentLocation.id);
          this.getLocations();
        } else {
          this.currentLocation = {
            name: this.defaultCurrentLocation,
            id: null,
          };
          this.updateRegionId(null);
          this.getLocations();
        }
      }
    },
    async getLocations() {
      const { data } = await api.get("/findLocations");
      this.locations = data.filter((e) => e.id !== this.currentLocation.id);
    },
    getAvatarName() {
      this.userName = localStorage.getItem("accessUserName");
      this.avatarName = `${this.userName[0]}${this.userName[1]}`.toUpperCase();
    },
    goToHome() {
      this.currentLocation = { name: this.defaultCurrentLocation, id: null };
      this.updateRegionId(null);
      this.getLocations();
      this.$router.push({ name: "home" });
    },
    handleCommand(command) {
      if (command === "logout") {
        this.updateRegionId(null);
        this.logout();
      } else if (command === this.defaultCurrentLocation) {
        this.currentLocation = { name: this.defaultCurrentLocation, id: null };
        this.getLocations();
        this.updateRegionId(null);
        this.$router.push({ name: "home" });
      } else {
        const currentLocation = this.locations.find((e) => e.name === command);
        this.currentLocation = currentLocation;
        this.locations = this.locations.filter((e) => e.name !== command);
        this.getLocations();
        this.updateRegionId(currentLocation.id);
        if (this.$route.path !== "/apportionmentBylocation") {
          this.$router.push({ name: "apportionmentByLocation" });
        }
      }
    },
  },
};
</script>
